<template>
  <div class="Header">
    <div id="header">
      <MobileSidebar
        :section_list="section_list"
        :cartProducts="cartProducts"
        :user="user"
        :logged="logged"
        :search_subcategory="search_subcategory"
        :id_search_category="id_search_category"
        :id_search_subcategory="id_search_subcategory"
        :menu_toggle="menu_toggle"
      />
      <MobileNavbar />
      <DesktopNavbar
        :section_list="section_list"
        :cartProducts="cartProducts"
        :user="user"
        :logged="logged"
        :scrollPosition="scrollPosition"
        :categories="categories"
        :search_subcategory="search_subcategory"
        :id_search_category="id_search_category"
        :id_search_subcategory="id_search_subcategory"
      />
    </div>
  </div>
</template>

<script>
import { deleteTokens, getCartItems } from '@/helpers/localStorage.helpers';
import { getCategories } from '@/service/categories.service';
import { mapState, mapMutations } from 'vuex';
import DesktopNavbar from '@/components/general/Header/Navbar/desktop/DesktopNavbar';
import MobileNavbar from '@/components/general/Header/Navbar/mobile/MobileNavbar';
import MobileSidebar from '@/components/general/Header/Navbar/mobile/MobileSidebar';

export default {
  name: 'Header',
  props: [
    'section_list',
    'user',
    'logged',
    'scrollPosition',
    'id_search_category',
    'id_search_subcategory',
    'search_subcategory',
  ],
  components: {
    DesktopNavbar,
    MobileNavbar,
    MobileSidebar,
  },
  data() {
    return {
      categories: [],
      menu_toggle: false,
    };
  },
  computed: mapState(['cartProducts', 'loggedUser']),
  methods: {
    ...mapMutations(['SET_CART_PRODUCTS']),

    loc_logout() {
      this.logged = false;
      deleteTokens();
      this.$router.push('/');
      location.reload();
    },

    getLocalProducts() {
      const products = getCartItems();
      if (products) {
        this.SET_CART_PRODUCTS(products);
      }
    },

    toogle() {
      if (this.menu_toggle) {
        this.menu_toggle = false;
      } else {
        this.menu_toggle = true;
      }
    },

    listCategories() {
      getCategories()
        .then((response) => {
          this.categories = response.data;
        })
        .catch((error) => {});
    },

    setSearch_category(value) {
      this.$parent.setSearch_category(value);
    },

    setSearch_subcategory_toSeccion(subcategory_id, subcategory_description, section) {
      this.$parent.setSearch_subcategory_toSeccion(
        subcategory_id,
        subcategory_description,
        section,
      );
    },

    setSearch_subcategory(subcategory_id, subcategory_description, idcategoria) {
      this.$parent.setSearch_subcategory(subcategory_id, subcategory_description, idcategoria);
    },
  },
  created() {
    this.getLocalProducts();
    this.listCategories();
  },
};
</script>

<style lang="scss" src="./Header.scss"></style>
